import "./BottomNavigation.css";

import DashboardSVG from "./Icons/DashboardSVG";
import DealsSVG from "./Icons/DealsSVG";
import PropertySVG from "./Icons/PropertySVG";
import ClientsSVG from "./Icons/ClientsSVG";
import AgentsSVG from "./Icons/AgentsSVG";

import {
  getAuth,
  //  onAuthStateChanged
} from "firebase/auth";

import React, { useCallback, useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { getLocalStorageItem } from "../../controllers/localStorage/getLocalStorage";
import { UserRoutes } from "../../Routing/UserRoutes";
import { AdminRoutes } from "../../Routing/AdminRoutes";
import MoreSVG from "./Icons/MoreSVG";
import NavsModal from "./NavsModal/NavsModal";
import SettingsSVG from "./Icons/SettingsSVG";
import ExpenseSVG from "./Icons/ExpenseSVG";
import MarketingSVG from "./Icons/MarketingSVG";
import AppointmnetsSVG from "./Icons/AppointmnetsSVG";

const isModuleAccessible = ({
  id,
  path,
  title,
  layout,
  parent,
  component,
  icon,
  activeIcon,
}) => {
  let isAccessible = true;
  let role = getLocalStorageItem("role");
  let permissions = getLocalStorageItem("permissions");
  if (!permissions) {
    role = "agent";
  }
  /** If user is admin and permissions is set to all then user has all permissions */
  if (role === "admin" && permissions === "all") isAccessible = true;
  else if (role === "agent") {
    /** Agents routes */
    if (["agents", "agents_details"].includes(id)) isAccessible = false;
    // else if (["properties"].includes(id)) isAccessible = false;
    else if (["leads"].includes(id)) isAccessible = false;
    else if (["expense"].includes(id)) isAccessible = false;
    /** Payment routes */ else if (["payments"].includes(id))
      isAccessible = false;
    // /** Leads routes */ else if (
    //   ["leads", "leads_details"].includes(id) &&
    //   !permissions.leads.read
    // )
    // isAccessible = false;
    // /** Properties routes */ else if (
    //   [
    //     "properties",
    //     "properties_add",
    //     "properties_edit",
    //     "properties_details",
    //   ].includes(id) &&
    //   !permissions.property.read
    // )
    //   isAccessible = false;
    /** Rental Management routes */ else if (
      ["rental_management", "rental_management_tenant_info"].includes(id) &&
      !permissions.rental_management.read
    )
      isAccessible = false;
  }
  return isAccessible;
};

let NavsInModal = [];
let NavsInMenu = [];
let totalNavs = [];

totalNavs = UserRoutes.filter(
  (route) =>
    route.layout === "user" && route.parent && isModuleAccessible(route)
);
NavsInMenu = totalNavs.filter((route, index) => {
  return route && index < 5;
});

NavsInModal = totalNavs.filter((route, index) => {
  return route && index >= 5;
});

const BottomNavigation = () => {
  const [NavModalItems, setNavModalItems] = useState(false);

  const path = useLocation().pathname;
  const [isUserSuperAdmin, setIsUserSuperAdmin] = useState(false);

  useEffect(() => {
    getAuth().onAuthStateChanged((user) => {
      if (user) {
        user.getIdTokenResult().then((idTokenResult) => {
          if (idTokenResult.claims.admin) {
            setIsUserSuperAdmin(true);
          }
        });
      }
    });
  }, []);

  const isModuleAccessible = useCallback(
    ({ id, path, title, layout, parent, component, icon, activeIcon }) => {
      let isAccessible = true;
      let role = getLocalStorageItem("role");
      let permissions = getLocalStorageItem("permissions");
      if (!permissions) {
        role = "agent";
      }
      /** If user is admin and permissions is set to all then user has all permissions */
      if (role === "admin" && permissions === "all") isAccessible = true;
      else if (role === "agent") {
        /** Agents routes */
        if (["agents", "agents_details"].includes(id)) isAccessible = false;
        // else if (["properties"].includes(id)) isAccessible = false;
        else if (["leads"].includes(id)) isAccessible = false;
        else if (["expense"].includes(id)) isAccessible = false;
        /** Payment routes */ else if (["payments"].includes(id))
          isAccessible = false;
        // /** Leads routes */ else if (
        //   ["leads", "leads_details"].includes(id) &&
        //   !permissions.leads.read
        // )
        // isAccessible = false;
        // /** Properties routes */ else if (
        //   [
        //     "properties",
        //     "properties_add",
        //     "properties_edit",
        //     "properties_details",
        //   ].includes(id) &&
        //   !permissions.property.read
        // )
        //   isAccessible = false;
        /** Rental Management routes */ else if (
          ["rental_management", "rental_management_tenant_info"].includes(id) &&
          !permissions.rental_management.read
        )
          isAccessible = false;
      }
      return isAccessible;
    },
    []
  );

  const RenderNavSVG = (name, active) => {
    switch (name) {
      case "Dashboard":
        return <DashboardSVG activeSvgColor={active ? "#4c3ca6" : "#969BA0"} />;
      case "Deals":
        return <DealsSVG activeSvgColor={active ? "#4c3ca6" : "#969BA0"} />;
      case "Properties":
        return <PropertySVG activeSvgColor={active ? "#4c3ca6" : "#969BA0"} />;
      case "Clients":
        return <ClientsSVG activeSvgColor={active ? "#4c3ca6" : "#969BA0"} />;
      case "Appointments":
        return (
          <AppointmnetsSVG activeSvgColor={active ? "#4c3ca6" : "#969BA0"} />
        );
      case "Agents":
        return <AgentsSVG activeSvgColor={active ? "#4c3ca6" : "#969BA0"} />;
      case "Marketing":
        return <MarketingSVG activeSvgColor={active ? "#4c3ca6" : "#969BA0"} />;
      case "Expense":
        return <ExpenseSVG activeSvgColor={active ? "#4c3ca6" : "#969BA0"} />;
      case "Settings":
        return <SettingsSVG activeSvgColor={active ? "#4c3ca6" : "#969BA0"} />;

      default:
        break;
    }
  };

  return (
    <>
      {NavModalItems === true && (
        <div className="nav-modal-container">
          {NavsInModal.filter(
            (route) =>
              route.layout === "user" &&
              route.parent &&
              isModuleAccessible(route)
          ).map((item, index) => {
            const isActive = path === item.path;
            const isChildActive = path.includes(item.path);

            return (
              <Link
                className="nav-modal-content"
                to={item.path}
                onClick={() => {
                  setNavModalItems(false);
                }}
              >
                <div className="nav-modal-svg">
                  {RenderNavSVG(item.title, isActive || isChildActive)}
                </div>
                <div
                  className="nav-modal-title"
                  style={{
                    color: isActive || isChildActive ? "#4c3ca6" : "initial",
                  }}
                >
                  {item.title}
                </div>
              </Link>
            );
          })}
          {/* <div className="nav-modal-content">
            <div className="nav-modal-svg">
              <SettingsSVG activeSvgColor={"#929292"} />
            </div>
            <div className="nav-modal-title">Settings</div>
          </div>
          <div className="nav-modal-content">
            <div className="nav-modal-svg">
              <ExpenseSVG activeSvgColor={"#4c3ca6"} />
            </div>
            <div className="nav-modal-title">Expense</div>
          </div> */}
        </div>
      )}

      <div className="app-navigation-container">
        {NavsInMenu.map((item, index) => {
          const isActive = path === item.path;
          const isChildActive = path.includes(item.path);

          return (
            <Link
              onClick={() => setNavModalItems(false)}
              className="nav-container"
              to={item.path}
            >
              <div className="nav-icon">
                {RenderNavSVG(item.title, isActive || isChildActive)}
              </div>
              <div
                className="nav-title"
                style={{
                  color: isActive || isChildActive ? "#4c3ca6" : "initial",
                }}
              >
                {item.title}
              </div>
            </Link>
          );
        })}
        <MoreSVG SVGClick={() => setNavModalItems(!NavModalItems)} />

        {/* {navsInModel.map((item, index) => {
        return (
          <Link className="nav-container" to={item.path}>
            <div className="nav-icon">{RenderNavSVG(item.title)}</div>
            <div className="nav-title">{item.title}</div>
          </Link>
        );
      })} */}
      </div>
    </>
  );
};

export default BottomNavigation;
